'use strict';

exports.__esModule = true;

var _polished = require('polished');

var brandPrimaryAccessible = '#0F9CEB';
var hoverDarken = 0.1;
var activeDarken = 0.2;

var colors = {
  white: '#fff',
  black: '#0f1114',

  grayBase: '#000',
  grayDarker: '#262b33',
  grayDark: '#373d46',
  gray: '#646d78',
  grayLight: '#99a4b1',
  grayLightLighter: '#c6cacb',
  grayLighter: '#ecf0f1',
  grayLightest: '#f2f5f5',
  grayLightestHover: '#c0cdd1',

  grayCirrus95: '#f2f5f5',
  grayCirrocumulus86: '#d6dae0',
  grayStratus48: '#69778c',
  grayCumulonimbus22: '#30363f',

  brandPrimaryAccessible: brandPrimaryAccessible,
  brandPrimary: '#5ebff3',
  brandSecondary: '#52beac',
  brandSuccess: '#6ebc66',
  brandInfo: '#697dd2',
  brandWarning: '#f59f5d',
  brandDanger: '#d95554',

  labelInsightPurple: '#a574ca',
  cardBorderColor: '#d3d8dd',
  marketingPanelBackgroundColor: '#fbfbfb',
  smartLabelBlue: '#24338a',

  boxShadowColor: 'rgba(0, 0, 0, 0.125)',
  backdropColor: 'rgba(15, 17, 20, 0.5)',

  btnPrimaryAccessibleHover: (0, _polished.darken)(hoverDarken, brandPrimaryAccessible),
  btnPrimaryAccessibleActive: (0, _polished.darken)(activeDarken, brandPrimaryAccessible),

  btnPrimaryHover: '#2facef',
  btnPrimaryHoverBorder: '#25a8ef',
  btnPrimaryFocus: '#2facef',
  btnPrimaryFocusBorder: '#0f84c3',
  btnPrimaryActiveFocus: '#119ee9',
  btnPrimaryActiveFocusBorder: '#0f84c3',

  btnSecondaryHover: '#3ca190',
  btnSecondaryHoverBorder: '#3a9989',
  btnSecondaryFocus: '#3ca190',
  btnSecondaryFocusBorder: '#27695e',
  btnSecondaryActiveFocus: '#3ca190',
  btnSecondaryActiveFocusBorder: '#27695e',

  hoverDarken: hoverDarken,
  activeDarken: activeDarken
};

colors.cardFooterColor = colors.grayLight;
colors.textColor = colors.grayDark;
colors.inputBorderColor = colors.grayLightestHover;
colors.defaultButtonBorderColor = colors.grayDark;
colors.disabledButtonColor = colors.grayLightLighter;
colors.disabledDeselectedControlColor = colors.grayCirrus95;
colors.disabledSelectedControlColor = colors.grayCirrocumulus86;
colors.disabledControlBorderColor = colors.grayCirrocumulus86;
colors.controlBorderColor = colors.grayCumulonimbus22;
colors.controlBackgroundColor = colors.grayCumulonimbus22;
colors.defaultButtonGroupColor = colors.grayStratus48;

exports.default = colors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/styles/js/_colors.js
// module id = 158
// module chunks = 14